module.exports = [{
      plugin: require('D:/00079_Waldeck_Stadtverwaltung/00079_1435_Klosterrundgang_Ober-Werbe/Landingpage/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('D:/00079_Waldeck_Stadtverwaltung/00079_1435_Klosterrundgang_Ober-Werbe/Landingpage/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
